document.addEventListener("DOMContentLoaded", () => {
  // ---- Shared size-picker popup (built once, reused by every product card) ----
  let modal = null;

  function buildModal() {
    modal = document.createElement("div");
    modal.className = "maison-qa-modal";
    modal.setAttribute("hidden", "");
    modal.innerHTML = [
      '<div class="maison-qa-modal__overlay" data-qa-close></div>',
      '<div class="maison-qa-modal__dialog" role="dialog" aria-modal="true" aria-label="Choisir une taille">',
      '  <button type="button" class="maison-qa-modal__close" data-qa-close aria-label="Fermer">',
      '    <svg viewBox="0 0 24 24" width="18" height="18" fill="none"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
      "  </button>",
      '  <p class="maison-qa-modal__title">Choisissez votre taille</p>',
      '  <p class="maison-qa-modal__product"></p>',
      '  <div class="maison-qa-modal__sizes"></div>',
      "</div>",
    ].join("");
    document.body.appendChild(modal);
    modal
      .querySelectorAll("[data-qa-close]")
      .forEach((el) => el.addEventListener("click", closeModal));
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal && !modal.hasAttribute("hidden"))
        closeModal();
    });
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute("hidden", "");
    document.documentElement.style.overflow = "";
  }

  function openModal(card) {
    if (!modal) buildModal();
    const titleEl = card.querySelector(".maison-product-card__title a");
    modal.querySelector(".maison-qa-modal__product").textContent = titleEl
      ? titleEl.textContent.trim()
      : "";
    const sizesWrap = modal.querySelector(".maison-qa-modal__sizes");
    sizesWrap.innerHTML = "";
    const variants = card.querySelectorAll(".maison-product-card__variant");
    variants.forEach((v) => {
      const disabled = v.classList.contains("is-disabled");
      const b = document.createElement("button");
      b.type = "button";
      b.className = "maison-qa-modal__size" + (disabled ? " is-disabled" : "");
      b.textContent = v.textContent.trim();
      if (disabled) {
        b.disabled = true;
      } else {
        b.addEventListener("click", () => addVariant(v.dataset.variantId, b));
      }
      sizesWrap.appendChild(b);
    });
    modal.removeAttribute("hidden");
    document.documentElement.style.overflow = "hidden";
  }

  async function addVariant(variantId, btn) {
    if (!variantId || (btn && btn.classList.contains("loading"))) return;
    if (btn) btn.classList.add("loading");
    try {
      const res = await fetch(
        ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") +
          "cart/add.js",
        {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!res.ok) throw new Error("Add to cart failed");
      closeModal();
      document.dispatchEvent(new CustomEvent("maison:cart-drawer-reload"));
    } catch (err) {
      console.error(err);
    } finally {
      if (btn) btn.classList.remove("loading");
    }
  }

  document.querySelectorAll(".maison-product-card").forEach((card) => {
    const variants = card.querySelectorAll(".maison-product-card__variant");
    const addButton = card.querySelector(
      ".maison-product-card__add-to-cart__button"
    );
    const mobileAddButton = card.querySelector(
      ".maison-product-card__mobile-add"
    );
    if (!addButton && !mobileAddButton) return;

    let selectedVariantId = null;

    variants.forEach((variantEl) => {
      variantEl.addEventListener("click", () => {
        if (variantEl.classList.contains("is-disabled")) return;

        variants.forEach((v) => v.classList.remove("active"));
        variantEl.classList.add("active");
        selectedVariantId = variantEl.dataset.variantId;
      });
    });

    const handleQuickAdd = (btn) => {
      if (
        btn.classList.contains("is-disabled") ||
        btn.classList.contains("loading")
      )
        return;

      // Shopper already picked a size via the desktop hover chips → add it.
      if (selectedVariantId) {
        addVariant(selectedVariantId, btn);
        return;
      }

      const available = card.querySelectorAll(
        ".maison-product-card__variant:not(.is-disabled)"
      );
      if (available.length === 0) return;

      // Only one variant exists → no size choice to make, add directly.
      if (variants.length <= 1) {
        addVariant(available[0].dataset.variantId, btn);
        return;
      }

      // Multiple sizes and none chosen → make the shopper pick one.
      openModal(card);
    };

    if (addButton)
      addButton.addEventListener("click", () => handleQuickAdd(addButton));
    if (mobileAddButton)
      mobileAddButton.addEventListener("click", () =>
        handleQuickAdd(mobileAddButton)
      );
  });
});
